import { render, staticRenderFns } from "./CompanyConfiguration.vue?vue&type=template&id=41f8b7e7&"
import script from "./CompanyConfiguration.vue?vue&type=script&lang=ts&"
export * from "./CompanyConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports